import { APP_CONFIG, ASSETS_PATH } from '../../shared/global/base';

const INFOWINDOW_OFFSET_WIDTH = 0;
const INFOWINDOW_OFFSET_HEIGHT = 0;

export async function createInfoWindow(data: LocalMapData, iwconfig: InfoWindow, mapOnPopup?: boolean) {
    try {

        let contentString = await createContentString(data, iwconfig, mapOnPopup)

        return new google.maps.InfoWindow({
            content: contentString,
            pixelOffset: new google.maps.Size(INFOWINDOW_OFFSET_WIDTH, INFOWINDOW_OFFSET_HEIGHT)
        });
    }
    catch (e) {
        console.log(e);
    }

}

function createOpeningHoursHTML(data: OpeningHours[]) {
    let listElement = '';
    if (data.length) {
        listElement = '<ul class="m-OpeningHours__list m-space-top-10">';
        for (let idx in data) {
            let listItem = `<li class="m-OpeningHours__list__item">
                <span>${data[idx].Day}</span>
                <span class="m-OpeningHours__hours">
                    <span>${data[idx].OpeningHour}</span>
                     -
                    <span>${data[idx].ClosingHour}</span>
                </span>
            </li>`
            listElement += listItem;
        }
        listElement += '</ul>';
    }
    return listElement;
}

function createTags(tags: string[]) {
    const tagsHtml = tags.map(tag=>{
        return `<span class="PlaceInfo__tag">${tag}</span>`
    })
    return tagsHtml.join("");
}

export async function createContentString(data: LocalMapData, iwconfig: InfoWindow, mapOnPopup: boolean) {
    let contentString = `
        <div class="m-MapAllPlaces__info-window">
    `;
    try {
        if (!data.IsDominium) {
            contentString += `
            <div class="m-PlaceHeading m-PlaceHeading--map">
                <div class="m-PlaceHeading__image">
                    <img src="${iwconfig.LocalImage}" alt="">
                </div>
                <div class="PlaceInfo PlaceInfo--map">
        `;
        }
        else {
            contentString += `
            <div class="m-PlaceHeading m-PlaceHeading--map">
                <div class="m-PlaceHeading__image m-PlaceHeading__image--wider">
                    <img src="${iwconfig.LocalImageWide}" alt="">
                </div>
                <div class="PlaceInfo PlaceInfo--map">
        `;
        }

        if (data.Address) {
            contentString += `
                    <h5 class="PlaceInfo__street">${data.Address}</h5>
            `;
        }
        if (data.City) {
            contentString += `
                    <p class="PlaceInfo__city">${data.City}</p>
            `;
        }
        if (data.Tags && data.Tags.length > 0) {
            contentString+= `<div class="PlaceInfo__tags-list PlaceInfo__tags-list--map"> ${createTags(data.Tags)}
        </div>`
        }
        if (data.Phone  && !iwconfig.HidePhoneNumber) {
            contentString += `
                    <a href="tel:${data.Phone.replace(/\s/g, '')}" class="PlaceInfo__phone ${data.PhoneIsHidden ? 'is--hide' : ''}">${iwconfig.PhoneLinkText} ${data.Phone}</a>
            `;
        }

        if (data.OpeningHours.length > 0 && data.OpeningHoursAtLocation.length > 0) {
            contentString += `
                </div>
                <button class="m-MapAllPlaces__icon-toggle" data-mapallplaces-toggleicon>
                    <img src="${ASSETS_PATH}/images/arrowDown.svg" alt="">
                </button>
            </div>
            <div class="c-Tabs" data-jscomponent="Tabs" data-tabs-selected="online">
                <ul class="c-Tabs__list" role="tablist">
                    <li class="c-Tabs__li is--active">
                        <button class="c-Tabs__btn" aria-controls="online" role="tab" id="btn-online" aria-selected="true">${iwconfig.Tab1Text}</button>
                    </li>
                    <li class="c-Tabs__li">
                    <button class="c-Tabs__btn" aria-controls="onsite" role="tab" id="btn-onsite" aria-selected="false">${iwconfig.Tab2Text}</button>
                    </li>
                </ul>
                <div class="c-Tabs__content">
                    <div class="c-Tabs__tab is--active" id="online" role="tabpanel" aria-labelledby="btn-online">
                        <div class="m-OpeningHours m-OpeningHours--map" data-js="mapallplacesopeninghours">
                            <p class="bold">${iwconfig.Tab1Description}</p>
                            ${createOpeningHoursHTML(data.OpeningHours)}
                        </div>
                    </div>
                    <div class="c-Tabs__tab" id="onsite" role="tabpanel" aria-labelledby="btn-online" hidden>
                        <div class="m-OpeningHours m-OpeningHours--map" data-js="mapallplacesopeninghours">
                            <p class="bold">${iwconfig.Tab2Description}</p>
                            ${createOpeningHoursHTML(data.OpeningHoursAtLocation)}
                        </div>
                    </div>
                </div>
            </div>
            `;
        }
        else if (data.OpeningHours.length > 0) {
            contentString += `
                </div>
                <button class="m-MapAllPlaces__icon-toggle" data-mapallplaces-toggleicon>
                    <img src="${ASSETS_PATH}/images/arrowDown.svg" alt="">
                </button>
            </div>
            <div class="m-OpeningHours m-OpeningHours--map" data-js="mapallplacesopeninghours">
                ${createOpeningHoursHTML(data.OpeningHours)}
            </div>`
        }
        else if (data.OpeningHoursAtLocation.length) {
            contentString += `
                </div>
                <button class="m-MapAllPlaces__icon-toggle" data-mapallplaces-toggleicon>
                    <img src="${ASSETS_PATH}/images/arrowDown.svg" alt="">
                </button>
            </div>
            <div class="m-OpeningHours m-OpeningHours--map" data-js="mapallplacesopeninghours">
                ${createOpeningHoursHTML(data.OpeningHoursAtLocation)}
            </div>`
        } 
        else {
            contentString += `
                </div>
            </div>`;
        }

        const menuUrl = APP_CONFIG.navigation.menu;
        if (data.IsActive) {
            contentString += `
            <div class="FormResponse is--hide">
                <p class="FormResponse__text" data-mapallplaces-localchangeerror></p>
            </div>
            <button data-mapallplaces-localchange="${data.Id}" class="c-Button c-Button--filled c-Button--filled-secondary c-Button--d-block" >
                ${iwconfig.ActiveBtnText}
            </button>
        `;
        }
        else {
            contentString += `
            <div class="FormResponse">
                <p class="FormResponse__text">${data.InactiveMessage}</p>
            </div>`;
            // TODO remove after beta period
            if (data.IsInBeta) {
                contentString += `
                <a href="${menuUrl || '/'}" data-mapallplaces-localchange="${data.Id}" data-link class="c-Button c-Button--filled c-Button--filled-secondary c-Button--d-block">
                    ${iwconfig.InactiveBtnText}
                </a>`;
            }
        }
    }
    catch (e) { }

    contentString += `
        </div>
    `;

    return contentString;
}
